import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'commissionStrategyController';
export default {
    /**
     * 委外佣金策略列表
     */
    getCommissionStrategyList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCommissionStrategyList',
        type: requestType.Get
    },
    /**
     * 委外佣金策略删除
     */
    delCommissionStrategy: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'delCommissionStrategy',
        type: requestType.Get
    },
    /**
     * 委外佣金策略详情
     */
    getCommissionDetailsById: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCommissionDetailsById',
        type: requestType.Get
    },
    /**
     * 委外佣金策略新增
     */
    insertCommissionStrategy: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'insertCommissionStrategy',
        type: requestType.Post
    },
    // 委外佣金策略下拉列表
    selectCommissionStrategyList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'selectCommissionStrategyList',
        type: requestType.Get
    },
    /**
     * 委外列表编辑
     */
    editCommissionStrategy: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'editCommissionStrategy',
        type: requestType.Put
    },
};
